import { useEffect } from "react";
import { REQUESTS_SET_ACTIVE_PRODUCT } from "common/actions/common";

import { pazienHistory } from "common/components/pazienHistory";
import { history } from "common/components/history";

// Listens to history changes and performs tasks when it changes.
export function HistoryListener() {
    useEffect(() => {
        const unlisten = history.listen(() => REQUESTS_SET_ACTIVE_PRODUCT(pazienHistory.getCurrentFragmentProduct() || "Unknown"));
        return unlisten;
    }, []);

    useEffect(() => {
        const unlisten = history.listen(() => { document.title = `${pazienHistory.getCurrentFragmentProduct()} - Pazien`; });

        return unlisten;
    }, []);

    return null;
}
